import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import StageLayer, { Props } from '../_components/StageLayer';
import { ModuleOnValueUpdate } from '../../Module/_actions/ModuleActions';

const mapStateToProps = (store:Store, props:Props) => {
	let moduleIds = store.getIn(['create', 'layerList', 'layers', props.id, 'modules']);
	return {
		modules: store.getIn(['create', 'moduleList', 'modules'])
			.filter((value:any, key:any) => moduleIds.includes(key))
			.sortBy((value:any, key:any) => key, (a:any, b:any) => {
				a = moduleIds.valueSeq().findIndex((key:any) => key == a);
				b = moduleIds.valueSeq().findIndex((key:any) => key == b);
				return (a < b) ? -1 : (a > b) ? 1 : 0;
			}),
		visible: store.getIn(['create', 'layerList', 'layers', props.id, 'visible']),
		documentWidth: store.getIn(['create', 'document', 'width']),
		documentHeight: store.getIn(['create', 'document', 'height']),
		documentQuality: store.getIn(['create', 'document', 'quality']),
		useChunks: store.getIn(['create', 'document', 'useChunks']),
	}
};

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	updateModule: (moduleId:string, key:string, value:any) => dispatch(ModuleOnValueUpdate(moduleId, key, value)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(StageLayer);